(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  DNB.CareerBoards = {
    init: function () {
      document.querySelectorAll("[data-board-color]").forEach(function (el) {
        var color = el.getAttribute("data-board-color");
        if (color) el.style.setProperty("--board-color", color);
      });
    }
  };
})(window, document);
